<script>
    export default {
        name: "TabButton",

        inject: {
            tabs: {
                default() {
                    return {};
                }
            }
        },

        props: {
            tab: {
                default: null
            }
        },

        render(createElement) {
            const isActive = this.tabs.activeTab() === this.tab;

            let tabChildren;
            if (this.tab.pill) {
                tabChildren = [
                    createElement('span', this.tab.title),
                    createElement('span', {
                        staticClass: 'ml-1',
                        class: {
                            'pill-default-2': !isActive,
                            'pill-white': isActive
                        }
                    }, this.tab.pill)
                ]
            } else {
                tabChildren = this.tab.title;
            }

            return createElement('li', {
                staticClass: 'tab text-yanone',
                class: {
                    active: isActive,
                },
                attrs: {
                    style: this.tab.pill ? 'display: flex; align-items: center;' : ''
                },
                on: {
                    click: () => this.tabs.setActiveTab(this.tab)
                }
            }, tabChildren);
        }
    }
</script>